export const ProductBrand = {
  DCS: 'DCS',
  HML: 'HML',
  AQUA: 'AQUA',
  LM: 'LM',
  HM: 'HM',
  PM: 'PM',
  MNP: 'MNP',
  PP: 'PP',
  YT: 'YT',
  RS: 'RS',
  ATL: 'ATL',
  HN: 'HN',
} as const

export type ProductBrandType = typeof ProductBrand[keyof typeof ProductBrand]

export const productBrandNameMap: Partial<Record<typeof ProductBrand[keyof typeof ProductBrand], string>> = {
  [ProductBrand.DCS]: '汪喵星球',
  [ProductBrand.HML]: '小宅生活',
  [ProductBrand.AQUA]: '角落水族',
  [ProductBrand.LM]: '怪獸部落',
  [ProductBrand.HM]: 'HeroMama',
  [ProductBrand.PM]: '毛掌醫學',
  [ProductBrand.MNP]: '超凝小姐',
  [ProductBrand.PP]: '日日貓砂',
  [ProductBrand.YT]: '虎留香',
  [ProductBrand.RS]: '日幸',
  [ProductBrand.ATL]: '阿提拉',
  [ProductBrand.HN]: '海牛寵物',
}
